'use strict'
import React from 'react'
import PropTypes from 'prop-types'
import './InfoField.less'

const InfoField = ({ title, children }) => {
  return (
    <div className='nmc-details-page-info-field'>
      <label className='nmc-info-header'>{title}: </label>
      <span className='nmc-info-value'>{children}</span>
    </div>
  )
}

InfoField.defaultProps = {
  title: ''
}

InfoField.propTypes = {
  title: PropTypes.string
}

export default InfoField



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/InfoField/index.js